import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { orderBy } from 'lodash';
import { Article, Event } from '../../components/index';
import PhotoNextTrip from '../../assets/img/next-trip.jpg';
import PhotoHomeNext from '../../assets/img/home-next.jpg';
import PedroSm from '../../assets/img/planet-explorers-services.jpg';
import Patagonia from '../../assets/img/last/patagonia/8.jpg';
import { get } from '../../redux/modules/news';

class Services extends PureComponent {

  componentWillMount() {
    this.props.getAction();
  }

  render() {
    const { news: { values: { text, news, last_news, articles }, isFetching } } = this.props;
    if (isFetching) {
      return <div/>
    }
    const orderNews = orderBy(news, ['is_soon'], ['asc']);
    return (
      <div className="main events container">
        <div className="row">
          <div className="col-md-8">
            <div className="events__list">
              <div dangerouslySetInnerHTML={{ __html: text.body }}/>
              <h2>próximos eventos</h2>
              {
                orderNews.map((obj, index) => {
                  return <Event key={index} {...obj}/>;
                })
              }
            </div>
            {
              last_news.length > 0 &&
              <div className="events__list">
                <h2>últimos eventos</h2>
                {
                  last_news.map((obj, index) => {
                    return <Event last={true} key={index} {...obj}/>;
                  })
                }
              </div>
            }
          </div>

          <div className="col-md-4">
            <h2>Artigos</h2>
            <div className="events__news">
              {
                articles.map((obj, index) => {
                  return <Article key={index} {...obj}/>;
                })
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      news: state.news
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: get
      }, dispatch);
  }
)(Services);




// WEBPACK FOOTER //
// ./src/containers/events/Events.js